import React, { useEffect } from "react";

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Cookie Policy</h1>
      <h3 className="text-xl font-semibold mb-2">What are cookies?</h3>
      <p className="mb-4">
        To gather the information, including personal data, we may use cookies
        and similar technologies on our website. A cookie is a small data file
        sent to your browser and stored on your device, whether it's a computer,
        mobile phone, or other hardware. Cookies can be classified as either
        first-party cookies, which are placed on your device by the website
        you're visiting, or third-party cookies, which are placed by other
        entities, such as Google, through the website.
      </p>
      <p className="mb-4">Cookies serve various functions, including:</p>
      <ul className="list-disc list-inside mb-4">
        <li className="mb-2">
          Necessary Cookies: Essential for enabling basic website features, such
          as logging in. These cookies do not collect personal data.
        </li>
        <li className="mb-2">
          Functionality Cookies: Enhance your experience by providing added
          functionality. For instance, they may remember your name and email, so
          you don’t need to enter these details every time you comment.
        </li>
        <li className="mb-2">
          Analytics Cookies: Used to monitor website usage and performance.
        </li>
        <li className="mb-2">
          Advertising Cookies: Tailored to deliver advertisements relevant to
          your interests and limit how often they appear. They are usually set
          by advertising networks with the website operator’s consent. These
          cookies track your website visits and share this information with
          third parties like advertisers. Often, advertising cookies are linked
          to website functionality provided by these external organizations.
        </li>
      </ul>

      <p className="mb-4">
        Analytics cookies help FogTeams analyze the way the website is used. Our
        cookies store user identification numbers, pages visited, time spent on
        each page, clicks, and demographic information such as country, IP
        address, device, and operating system. We also use cookies to
        distinguish between users and sessions, identify new users, track
        traffic sources, and limit data request rates to manage website
        performance.
      </p>
      <p className="mb-4">
        Some cookies are necessary for website functionality, such as storing
        users' consent for placing advertising and other cookies. We also use
        advertising cookies from partners like Facebook, LinkedIn, and Twitter
        for retargeting and marketing purposes.
      </p>
    </div>
  );
};

export default CookiePolicy;
